const getShortDate = date => (date || new Date(Date.now())).toLocaleDateString().split('/').join('-')

module.exports = getShortDate



// WEBPACK FOOTER //
// ./src/utilities/getShortDate.js